import { DrawingTypeEnum, SectionStateStatus } from '../../common/shared.enums';
import { AppError } from '../../../core/common/errors/app-error';
import { Drawing } from '../../model';

export abstract class BlocState {}

export abstract class InitState extends BlocState {
  constructor() {
    super();
  }
}

//processing or loading
export class DrawingType<T> extends BlocState {
  public drawingType;

  constructor(public drawing: T, public loading: boolean = false) {
    super();
    if (this.drawing instanceof Drawing) {
      this.drawingType = this.loading ? SectionStateStatus.Loading : DrawingTypeEnum.Drawing;
    } else {
      this.drawingType = this.loading ? SectionStateStatus.LoadingTransparent : DrawingTypeEnum.NonDrawing;
    }
  }
}

//processing or loading
export class ProcessingState<T> extends DrawingType<T> {
  constructor(drawing: T) {
    super(drawing, true);
  }
}

//Ready state
export class ReadyState<T> extends BlocState {
  constructor(public data?: T | T[], public count?: number) {
    super();
  }
}

//Empty state
export class EmptyState extends BlocState {
  constructor() {
    super();
  }
}

//coming soon
export class ComingSoonState extends BlocState {
  constructor() {
    super();
  }
}

//Error state
export class ErrorState<T> extends DrawingType<T> {
  constructor(drawing: T, public error?: AppError) {
    super(drawing);
  }
}

//submitted state
export class SubmittedState<T> extends BlocState {
  constructor(public item?: T) {
    super();
  }
}

//Added state
export class AddedState<T> extends BlocState {
  constructor(public data: T | T[]) {
    super();
  }
}

export class DisconnectedState<T> extends DrawingType<T> {
  constructor(drawing: T) {
    super(drawing);
  }
}

// this state handle showing success snackbar => it used in base component
export class ShowSuccessMessageState<T extends BlocState> {
  constructor(public state: T, public messageTranslationKey: string, public customMessage?: string) {}
}

// state for loading component
export class ShowLoadingComponentState extends BlocState {
  constructor(public showLoading : boolean = false) {
    super();
  }
}

export class ShowPopUpLoadingState extends BlocState {
  constructor() {
    super();
  }
}

export class ShowLoadingSpinnerState extends BlocState {
}
